import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Cookie from 'js-cookie';
// config
import { config } from '../../config';
import { history } from '../../store';

// actions
import { getCustomerForImpersonation, loginSofologistFromJWT, sofologistLogout } from '../../actions/sofologist';
import MySofologyLogo from '../../layout/graphics/MySofologyLogo';
import SofologistHeader from '../../layout//SofologistHeader';
import OverlayLoader from '../../parts/OverlayLoader';
import CustomerMultiSelect from './CustomerMultiSelect';
import { getSofologistCookie } from '../../services/cookieService';

const FIND_TYPES = {
  orderRef: {
    displayText: 'Reference number',
    placeHolder: '1194567/1',
    requestObj: (state) => {
      const orderParts = state.customerFindInputValue.trim().split('/');
      return { orderRef: orderParts[0], orderNumber: orderParts[1] };
    }
  },
  email: {
    displayText: 'email address',
    placeHolder: 'username@domain.com',
    requestObj: customer => ({ SearchTerm: customer.username.trim() })
  },
  phoneNumber: {
    displayText: 'phone number',
    placeHolder: '0344 481 8181',
    requestObj: state => ({ SearchTerm: state.customerFindInputValue.replace(/\s/g, '').trim() })
  },
  address: {
    displayText: 'postcode',
    placeHolder: 'WA3 3UL',
    requestObj: state => ({
      postCode: state.customerFindInputValue.trim(),
      houseNameNumber: state.customerHouseNumber.trim()
    })
  }
};

class RetrieveCustomer extends Component {
  constructor(props) {
    super(props);
    const sofologistCookie = getSofologistCookie();
    if (sofologistCookie) {
      if(!sofologistCookie.location) {
        sofologistLogout();
      } else {
        props.loginSofologistFromJWT(sofologistCookie);

        this.state = {
          customerFindType: 'email',
          loading: false,
          errors: false,
          foundCustomers: [],
          customer: {
            username: this.getQueryVariable('customerId'),
            userId: this.getQueryVariable('customerId')
          }
        };
      }
    }
  }
  componentWillMount() {
    const customer = { 
      username: this.getQueryVariable('customerId'),
      userId: this.getQueryVariable('customerId')
    };

    this.setState({
      loading: false,
      errors: false,
      foundCustomers: [],
      customer
    });

    this.handleFindCustomers(customer);
  }
  getQueryVariable(variable) {
    const query = this.props.location.search.substring(1);
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      if (decodeURIComponent(pair[0]) === variable) {
        return decodeURIComponent(pair[1]);
      }
    }
    return '';
  }

  setFoundCustomers(customers = []) {
    this.setState({
      foundCustomers: customers
    });

    if (customers.length === 1) {
      this.handleSelectCustomer(customers[0]);
    }
  }

  handleErrors() {
    this.setState({
      loading: false,
      errors: 'Could not find a customer for those details'
    });
  }

  handleSelectCustomer(customer) {
    const sofologyUser = { token: null };
    const retailExperienceUser = {
      username: customer.Email,
      userId: customer.CustomerGuid,
      isLoggedIn: true
    };
    const cookieConfig = { domain: config.APP_INFO.COOKIE_DOMAIN, expires: 365 };
    Cookie.set('sofologyUser', sofologyUser, cookieConfig);
    Cookie.set('retailExperience.user', retailExperienceUser, cookieConfig);
    history.push('/');
  }

  handleFindCustomers(customer) {
    this.setState({ loading: true, errors: false, foundCustomers: [] });
    const { getCustomerForImpersonation } = this.props;
    const customerFindType = 'email';
    const request = FIND_TYPES[customerFindType].requestObj(customer);
    getCustomerForImpersonation(request)
      .then((res) => {
        this.setFoundCustomers(res.data);
        this.setState({ loading: false });
      })
      .catch(() => this.handleErrors());
  }

  render() {
    const { loading, errors, foundCustomers } = this.state;

    return (
      <React.Fragment>
        <SofologistHeader />
        <div
          className="u-flex-center-both--col c-customer-finder u-padding-top"
        >
          <div className="u-flex-center-both--col">
            <h1 className="admin-logo">
              <div className="">
                <MySofologyLogo textColor="black" />
                <div className="u-padding-bottom-micro">Admin</div>
              </div>
            </h1>

            <form
              style={{ maxWidth: '400px', position: 'relative' }}
              onSubmit={this.handleFindCustomers}
              method="post"
              className="form__admin  u-padding-x-small"
            >

              <OverlayLoader
                active={loading}
                background={'rgba(247, 247, 247, .8)'}
              />


              <GhostButton-
                text="Find Customer"
                onBtnClick={this.handleFindCustomers}
                disabled={loading}
                extraClass="u-w-100 u-padding-y-small"
              />

              <div
                className="errors"
              >
                {loading ? null : errors}
              </div>

            </form>

          </div>
        </div>
        <CustomerMultiSelect
          customers={foundCustomers}
          onClose={this.setFoundCustomers}
          onSelect={this.handleSelectCustomer}
        />
      </React.Fragment>);
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  getCustomerForImpersonation, loginSofologistFromJWT
}, dispatch);

export default connect(null, mapDispatchToProps)(RetrieveCustomer);



// WEBPACK FOOTER //
// ./src/pages/AdminPage/RetrieveCustomer.js